import React from "react";

const Saved = () => {
  return (
    <div>
      <h1>Saved</h1>
      <p>Welcome to the Saved page.</p>
    </div>
  );
};

export default Saved;
